import React from 'react';
import { Switch, Typography } from '@mui/material';
import { formatDate } from 'helpers/dateHelper';
import Flex from 'ui/Flex/Flex';
import { firstNameLastNameFormatter } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/agentColumnHelpers';
import { DetailedGradeAdvancementHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/GradeAdvancement/helpers/types';
import { toggleExclusion } from '../helpers/dataHelpers';

type Props = {
    hypothesis: DetailedGradeAdvancementHypothesis;
    excludedGradeAdvancementHypotheses?: number[];
    setExcludedGradeAdvancementHypotheses?: (
        excludedGradeAdvancementHypotheses: number[],
    ) => void;
};

const GradeAdvancementHypothesis = ({
    hypothesis,
    excludedGradeAdvancementHypotheses,
    setExcludedGradeAdvancementHypotheses,
}: Props): React.ReactElement => {
    const {
        id,
        agentFirstName,
        agentLastName,

        grade,
        startDate,
    } = hypothesis;
    const isExcluded = excludedGradeAdvancementHypotheses
        ? excludedGradeAdvancementHypotheses.includes(id)
        : false;

    return (
        <Flex align="center" justify="space-between">
            <Flex direction="column" align="flex-start">
                <Typography variant="body1SemiBold">
                    {firstNameLastNameFormatter({
                        lastName: agentLastName,
                        firstName: agentFirstName,
                    })}
                </Typography>
            </Flex>

            <Flex align="center" sx={{ gap: '1em' }}>
                <Typography
                    variant="body2"
                    color="primary"
                    sx={{ weight: 'bold' }}
                >
                    {grade}
                </Typography>
                <Typography variant="body2">
                    {formatDate(new Date(startDate))}
                </Typography>
            </Flex>
            {excludedGradeAdvancementHypotheses &&
                setExcludedGradeAdvancementHypotheses && (
                    <Flex align="center" sx={{ gap: '1em' }}>
                        <Switch
                            checked={!isExcluded}
                            onChange={() =>
                                toggleExclusion(
                                    excludedGradeAdvancementHypotheses,
                                    setExcludedGradeAdvancementHypotheses,
                                    id,
                                    isExcluded,
                                )
                            }
                        />
                    </Flex>
                )}
        </Flex>
    );
};

export default GradeAdvancementHypothesis;
